import { ApiResponse } from "../types/common";

import { ApiClient } from "./apiClient";

export interface ProfileData {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  profilePicture: string | null;
  city: string;
  country: string;
  region: string;
  addressLine1: string;
  addressLine2: string;
  postalCode: string;
}

export interface UpdateProfileRequest {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  profilePicture: string;
  city: string;
  country: string;
  region: string;
  addressLine1: string;
  addressLine2: string;
  postalCode: string;
}

const profileService = new ApiClient<ProfileData>("/Profile");

export const getMyProfile = (): Promise<ApiResponse<ProfileData>> => {
  return profileService.custom("get", "/my-profile");
};

export const updateProfile = (
  data: UpdateProfileRequest
): Promise<ApiResponse<ProfileData>> => {
  return profileService.custom("put", "/my-profile-update", data);
};

export default profileService;
